<template>
  <v-app>
    <v-main>
      <v-app-bar color="#0d0d0d" dense dark>
        <v-btn :href="featurePost === undefined ? hofHomeRoute : pageHofUrl" icon id="back-button">
          <v-icon>mdi-keyboard-backspace</v-icon>
        </v-btn>
        <v-toolbar-title class="pl-0">Hall of Fame</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleDrawer">
          <v-icon>mdi-filter</v-icon>
        </v-btn>
      </v-app-bar>
      <v-bottom-sheet persistent v-model="drawer">
        <hof-filter
          :reactions="reactions"
          :initialLoad="initialLoad"
          :searchParams="searchParams"
          :timeFrameOptions="timeFrameOptions"
          @initialLoad="initialLoad"
          @toggleDrawer="toggleDrawer"
        />
      </v-bottom-sheet>
      <v-container fluid>
        <v-row class="justify-content-center">
          <google-ad unit="300_250_unit" />
        </v-row>
        <hall-of-fame-card v-if="featurePost === undefined">
          <template v-slot:content>
            <hall-of-fame-header
              class="my-3"
              :title="name"
              :imageUrl="logoUrl"
              :showSubtitle="true"
            >
              <template v-slot:subtitle v-if="pages !== undefined">
                <v-dialog
                  v-model="showPageList"
                  width="500"
                >
                  <template v-slot:activator="{ on, attrs }">
                      <span class="text-wrap">
                        {{ pageNameList }}
                      </span>
                      <a v-bind="attrs" v-on="on">
                        Show All Pages
                      </a>
                  </template>
                  <v-card>
                    <v-toolbar elevation="0">
                      <v-toolbar-title style="word-break: break-word;" class="text-wrap pt-3">
                        Pages in {{ name }}
                      </v-toolbar-title>
                      <v-spacer/>
                      <v-btn icon @click="showPageList = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text>
                      <v-list-item v-for="(page, i) in pages" :key="i">
                        <v-list-item-content>
                          <v-list-item-title>
                            <a :href="page.hall_of_fame_url" target="_blank" class="text-wrap">
                              {{ page.name }}
                            </a>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </template>
            </hall-of-fame-header>
          </template>
        </hall-of-fame-card>
        <template v-else>
          <hall-of-fame-card class="my-2">
            <template v-slot:content>
              <hall-of-fame-post
                :post="featurePost"
                :reactions="reactions"
                :pageHofUrl="pageHofUrl"
                :showRanking="false"
              />
            </template>
          </hall-of-fame-card>
          <hall-of-fame-card>
            <template v-slot:content>
              <v-card class="my-2">
                <v-card-title>
                  More from {{ featurePost.page_name }}
                </v-card-title>
              </v-card>
            </template>
          </hall-of-fame-card>
        </template>
        <template v-if="performingInitialLoad">
          <hall-of-fame-card v-for="i in 10" :key="i">
            <template v-slot:content>
              <v-skeleton-loader
                class="skeleton"
                type="list-item-avatar, article"
              />
            </template>
          </hall-of-fame-card>
        </template>
        <template v-else>
          <hall-of-fame-card v-if="posts.length === 0">
            <template v-slot:content>
              <v-card
                outlined
                elevation="1"
                class="pa-2"
              >
                <v-card-title>
                  No posts found
                </v-card-title>
              </v-card>
            </template>
          </hall-of-fame-card>
          <template v-for="(post, index) in posts">
            <hall-of-fame-card :key="post.id">
              <template v-slot:content>
                <hall-of-fame-post
                  :hofRanking="index"
                  :post="post"
                  :reactions="reactions"
                  :pageHofUrl="pageHofUrl"
                />
              </template>
            </hall-of-fame-card>
            <hall-of-fame-card v-if="(index+1)%adFrequency == 0" :key="`ad${post.id}`">
              <template v-slot:content>
                <v-card
                  outlined
                  elevation="1"
                  class="pa-2"
                >
                  <v-card-text>
                    <v-row class="justify-content-center">
                      <google-ad unit="300_250_unit" />
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
            </hall-of-fame-card>
          </template>
          <hall-of-fame-card v-if="!stopInfiniteScroll">
            <template v-slot:content>
              <v-skeleton-loader
                v-intersect="intersect"
                class="skeleton"
                type="list-item-avatar, article"
                loading
              />
            </template>
          </hall-of-fame-card>
        </template>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import hallOfFamePost from "./components/hallOfFamePost.vue";
import hofFilter from "./components/hofFilter.vue";
import hallOfFameCard from "./components/hallOfFameCard.vue";
import hallOfFameHeader from "./components/hallOfFameHeader.vue";

export default {
  components: { hallOfFamePost, hofFilter, hallOfFameCard, hallOfFameHeader },
  data: () => {
    return {
      adFrequency: 4,
      drawer: false,
      group: null,
      performingInitialLoad: true,
      stopInfiniteScroll: false,
      nextPageUrl: null,
      posts: [],
      showPageList: false,
      searchParams: {
        timeFrame: "a",
        reaction: "total",
      },
      timeFrameOptions: [
        { name: "All Time", value: "a" },
        { name: "Year", value: "y" },
        { name: "Month", value: "m" },
      ],
    };
  },
  props: {
    name: String,
    apiUrl: String,
    logoUrl: String,
    reactions: Object,
    hofHomeRoute: String,
    pageHofUrl: String,
    featurePost: Object,
    pages: Array,
  },
  created() {
    this.initialLoad();
  },
  methods: {
    initialLoad() {
      this.stopInfiniteScroll = true;
      this.performingInitialLoad = true;
      axios
        .get(this.apiUrl, {
          params: this.searchParams,
        })
        .then((response) => {
          this.posts = response.data.data;
          if (response.data.next_page_url) {
            this.nextPageUrl = response.data.next_page_url;
            this.stopInfiniteScroll = false;
          }
          this.performingInitialLoad = false;
        });
    },
    loadMore() {
      axios
        .get(this.nextPageUrl, {
          params: this.searchParams,
        })
        .then((response) => {
          this.posts = this.posts.concat(response.data.data);
          if (response.data.next_page_url) {
            this.nextPageUrl = response.data.next_page_url;
          } else {
            this.stopInfiniteScroll = true;
          }
        });
    },
    getPositionStyle(i) {
      let styles = ["gold", "silver", "bronze"];
      if (i < styles.length) {
        return styles[i];
      }
      return "";
    },
    setTimePeriod(t) {
      this.timePeriod = t;
    },
    timeAgo(t) {
      let time = moment(t);
      return moment(time).fromNow();
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    intersect(entries, observer) {
      if (entries[0].isIntersecting && !this.stopInfiniteScroll) {
        this.loadMore();
      }
    },
  },
  computed: {
    pageNameList() {
      if (!this.pages) {
        return null;
      }
      if (this.pages.length <= 5) {
        return this.pages.map(p => p.name).join(', ')
      }
      return `${this.pages.slice(0, 5).map(p => p.name).join(', ')}...`
    },
  },
};
</script>
<style scoped>
.v-skeleton-loader {
  background-color: #fff !important;
}
a {
  text-decoration: underline !important;
}
.v-text-field__details {
  height: 0 !important;
  min-height: 0 !important;
  margin: 0 !important;
}
#group-name {
  margin-top: 5px;
}
.time-ago {
  color: #7a7a7a;
}
.skeleton {
  filter: drop-shadow(2px 5px 3px #afafaf80) !important;
  padding: 5px !important;
  padding-top: 15px !important;
  border: 1px solid #f9f9f9;
}
#filter-menu {
  width: 100% !important;
}
.v-expansion-panel:before {
  box-shadow: none !important;
}
.inactive {
  opacity: 30%;
}
.active {
  opacity: 100%;
}
.theme--light.v-list {
  color: rgba(100, 100, 100, 0.87);
}
.reaction {
  font-size: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 30px;
  width: 40px;
  margin-right: 2px;
}
#large-icon {
  width: 100%;
  object-fit: contain;
  background-color: white;
  border-radius: 500px;
}
#header-icon-wrapper {
  display: flex;
  align-items: center;
  width: 30%;
}
#header-text-wrapper {
  display: flex;
  flex-direction: column;
  word-wrap: break-word;
}
#posts-wrapper {
  height: 100%;
  padding: 0 10px 0 10px;
}
#header-pages-list {
  color: #aaaaaa;
}
#back-button {
  color: white !important;
  text-decoration: none !important;
}
</style>
